var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClassContainer(),on:{"click":_vm.callAction}},[_c('span',{staticClass:"material-icons",class:_vm.getClassIcon()},[_vm._v(_vm._s(_vm.iconName))]),_c('div',{class:_vm.getClasstext()},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }